import { gql } from "@apollo/client";

export const GET_NARRATIVE_SEGMENTS = gql`
  query GET_NARRATIVE_SEGMENTS($incidentId: ID!, $originatorId: ID!) {
    initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
      __typename
      blocked(employeeId: $originatorId)
      narrativesBlocked(employeeId: $originatorId)
      employee {
        id
      }
      inactive
      id
      incidentNumber

      ori {
        id
        abbreviation
        agencyType
        oriName
        requireDrugType
      }
      sealed
      locked
      narrativeSegments {
        id
        content
        createdAt
        incident {
          id
        }
        lastUpdatedAt
        lastUpdatedBy {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        lockedBy {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        officer {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
